export const getNotificationFromPayload = (payload) => {
  const response = {
    success: null,
    error: null
  };

  if (!payload || !payload._meta || !payload._meta.notification) {
    return response;
  }

  const notification = payload._meta.notification;

  if (notification.success) {
    response.success = notification.success;
  }
  if (notification.error) {
    response.error = notification.error;
  }

  return response;
};
